module.exports = __webpack_public_path__ + "static/media/IconoPila.400a3817.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-inalambrico/IconoPila.svg
// module id = 199
// module chunks = 0